export enum EStatusRecive {
    activo = 'ACTIVE',
    liveTracking = 'LIVETRACKING',
    stopMotor = 'STOPPED',
    noData = 'NO DATA',
}

export enum EStateMotor {
    apagado = 'Apagado',
    encendido = 'Encendido',
    offline = 'Sin Conexión',
    esperando = 'Esperando respuesta',
}

export enum ECardStatusMotor {
    liveTracking = 'LIVE_TRACKING',
    stopMotor = 'MOTOR',
}

export enum ELiveTrackingState {
    dataError = 'Data Error',
    off = 'OFF',
    on = 'ON',
}

export enum EMotorState {
    dataError = 'Data Error',
    stop = 'STOP',
    run = 'RUN',
}

export enum ECommandStatus {
    queued = 'QUEUED',
    sent = 'SENT',
    confirmed = 'DONE',
    error = 'ERROR',
}

export const commandToSend: Record<ECardStatusMotor, Record<string, string>> = {
    [ECardStatusMotor.liveTracking]: {
        true: 'ON',
        false: 'OFF',
    },
    [ECardStatusMotor.stopMotor]: {
        true: 'RUN',
        false: 'STOP',
    },
};


export const liveTrackingToStateMotor: Record<ELiveTrackingState, EStateMotor> =
{
    [ELiveTrackingState.dataError]: EStateMotor.offline,
    [ELiveTrackingState.off]: EStateMotor.apagado,
    [ELiveTrackingState.on]: EStateMotor.encendido,
};

export const stopMotorToStateMotor: Record<EMotorState, EStateMotor> = {
    [EMotorState.dataError]: EStateMotor.offline,
    [EMotorState.stop]: EStateMotor.apagado,
    [EMotorState.run]: EStateMotor.encendido,
};

export const commandStatusToString: Record<ECommandStatus, string> = {
    [ECommandStatus.queued]: 'Procesando',
    [ECommandStatus.sent]: 'Enviado',
    [ECommandStatus.confirmed]: 'Confirmado',
    [ECommandStatus.error]: 'Error',
}


//TODO: sacar cuando saquemos la sección vieja de historial de estado del motor

export const ConfigMotorState: Record<
EStatusRecive,
Array<{ liveTracking?: EStateMotor; stopMotor?: EStateMotor }>
> = {
    [EStatusRecive.activo]: [
        { liveTracking: EStateMotor.apagado },
        { stopMotor: EStateMotor.encendido },
    ],
    [EStatusRecive.liveTracking]: [
        { liveTracking: EStateMotor.encendido },
        { stopMotor: EStateMotor.encendido },
    ],
    [EStatusRecive.stopMotor]: [
        { liveTracking: EStateMotor.apagado },
        { stopMotor: EStateMotor.apagado },
    ],
    [EStatusRecive.noData]: [
        { liveTracking: EStateMotor.offline },
        { stopMotor: EStateMotor.offline },
    ],
};

export const statusReciveToStateMotor: Record<EStatusRecive, EStateMotor> = {
    [EStatusRecive.stopMotor]: EStateMotor.apagado,
    [EStatusRecive.liveTracking]: EStateMotor.encendido,
    [EStatusRecive.activo]: EStateMotor.encendido,
    [EStatusRecive.noData]: EStateMotor.offline,
};

export const stateMotorToStatusRecive: Record<EStateMotor, EStatusRecive> =
    Object.fromEntries(
        Object.entries(statusReciveToStateMotor).map(([a, b]) => [b, a])
    ) as Record<EStateMotor, EStatusRecive>;
